<template>
  <div>
    <Home v-if="!$store.state.auth.logged_in" />

    <RouterView v-if="$store.state.auth.logged_in" v-slot="{ Component, route }">
      <Transition :name="route?.meta?.transition || 'page-slide-left'" mode="out-in">
        <component :is="Component" :key="route.name" />
      </Transition>
    </RouterView>
  </div>
</template>

<script>
import Home from '@/views/Home.vue'

export default {
  name: 'Auth',
  components: { Home },
}
</script>
